module.exports = __webpack_public_path__ + "static/media/pencilDude.d526c9ff.jpeg";